//requests for project sort
const PROJECTS_BY_NEW_ARCHITECTURE = 'getSortedUserProjectsV2';
export { PROJECTS_BY_NEW_ARCHITECTURE };
